import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "SupplementDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'COMPLAINT'
    }
  },
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      form: {
        msg: ''
      },
      rules: {
        msg: [{
          required: true,
          message: '请输入补充提示',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.form.msg = '';
      }
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
      this.$refs.form.clearValidate();
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.submitLoading = true;
          _this.$api.requestSupplement({
            id: _this.currentId,
            note: _this.form.msg
          }).then(function () {
            var _this$data;
            _this.$emit('confirm');
            _this.$operationLog.push({
              operationType: "complaint",
              code: 'request_additional_info',
              detailBatchNo: _this.currentId,
              userId: (_this$data = _this.data) === null || _this$data === void 0 ? void 0 : _this$data.userId,
              operationOrderType: _this.type
            });
            _this.handleClose();
          }).finally(function () {
            _this.submitLoading = false;
          });
        }
      });
    }
  }
};